import { BasePageModel } from '../../Common/models/base-page-model';

export var page = new BasePageModel();